<template>
  <section class="content-list">
    <template v-for="(item, index) in list" :key="index">
      <div class="user" v-if="item.role === 'user'">
        <p
          class="text"
          v-for="(text, idex2) in item.content.split('\n\n')"
          :key="'text_' + idex2"
        >
          {{ text }}
        </p>
      </div>
      <div class="chatgpt" v-else>
        <div class="chat-title">
          <p class="name">AI Assistant</p>
          <img
            class="chat-icon"
            src="@/assets/icons/settings_5@3x.png"
            alt=""
          />
        </div>
        <p
          class="text"
          v-for="(text, idex2) in item.content.split('\n\n')"
          :key="'text_' + idex2"
        >
          {{ text }}
        </p>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: "content-list",
  props: ["list"],
};
</script>

<style lang="scss" scoped>
.content-list {
  padding: 0 20px;
  font-size: 16px;
  color: #fff;
  text-align: left;
  .user {
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 20px;
    padding: 15px 20px;
    font-style: italic;
    margin-bottom: 20px;
    color: rgba(255, 255, 255, 0.7);
  }
  .text {
    margin-bottom: 12px;
  }
  .chatgpt {
    background-color: rgba(30, 44, 77, 1);
    border-radius: 20px;
    padding: 15px 20px;
    margin-bottom: 20px;
    .chat-title {
      display: flex;
      justify-content: space-between;
      color: rgba(107, 122, 153, 1);
      margin-bottom: 15px;
      .chat-icon {
        width: 20px;
        height: 18px;
      }
    }
  }
}
</style>
